import React, {useEffect, useState} from "react";
import MainLayout from "../MainLoyout/MainLayout";
import {
    Box,
    Button,
    CircularProgress,
    Container,
    FormControl,
    FormControlLabel,
    Grid, InputLabel,
    Paper, Select,
    Switch
} from "@mui/material";
import Title from "../Title";
import {DataGrid, GridToolbar} from "@mui/x-data-grid";
import Skeleton from "@mui/material/Skeleton";
import Api from "../../Services/Api";
import CreateFeed from "../Drawers/CreateFeed";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import {CopyAll, QueryStats, Refresh, Share, Star} from "@mui/icons-material";
import IconButton from "@mui/material/IconButton";
import {formatDistanceToNow, parseISO} from "date-fns";
import MenuItem from "@mui/material/MenuItem";
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";
import {AdapterDateFns} from "@mui/x-date-pickers/AdapterDateFns";
import {DatePicker} from "@mui/x-date-pickers-pro";
import TextField from "@mui/material/TextField";
import Tooltip from "@mui/material/Tooltip";
import {makeStyles, styled} from "@mui/material";
import {useForm} from "react-hook-form";
import {Autocomplete} from "@mui/material";
import {Controller} from 'react-hook-form';
import KPIS from "./KPIS";
import {useSearchParams} from "react-router-dom";


const DemandSupply = () => {


    const [loading, setLoading] = React.useState(true);
    const [pageSize, setPageSize] = React.useState(100);
    const [startDate, setStartDate] = React.useState(new Date());
    const [endDate, setEndDate] = React.useState(new Date());

    const [supplyPartners, setSupplyPartners] = React.useState([]);
    const [demandPartners, setDemandPartners] = React.useState([]);

    const {
        register,
        handleSubmit,
        setValue,
        watch,
        control,
        reset,
        formState: {errors},
    } = useForm();


    const [demandSupply, setDemandSupply] = React.useState([]);
    const [demandFeeds, setDemandFeeds] = React.useState([]);
    const [supplyFeeds, setSupplyFeeds] = React.useState([]);


    const [loadingRows, setLoadingRows] = useState(new Set());
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [updatingRowId, setUpdatingRowId] = useState(null);
    const [checkedState, setCheckedState] = useState(false);
    const [dataForm, setDataForm] = useState(null);

    let [searchParams, setSearchParams] = useSearchParams();




    const [confirmDialog, setConfirmDialog] = React.useState(null);
    const noButtonRef = React.useRef(null);
    const [promiseArguments, setPromiseArguments] = React.useState(null);

    const handleNo = () => {
        const { resolve, oldRow } = promiseArguments;
        resolve(oldRow); // Reject the update.
        setPromiseArguments(null);
    };

    const handleYes = () => {
        const { resolve, oldRow, newRow, updatedField, newValue } = promiseArguments;
        Api.supplyDemandUpdate({ id: newRow.demand_feed_id + "-" + newRow.supply_feed_id, field: updatedField, value: newValue }).then(r => {
            console.log(r);

            // Find the index of the updated row
            const rowIndex = demandSupply.findIndex(row => row.demand_feed_id === newRow.demand_feed_id && row.supply_feed_id === newRow.supply_feed_id);

            // Create a new array with the updated row
            const updatedDataRows = [...demandSupply];
            updatedDataRows[rowIndex] = newRow;

            console.log(updatedDataRows[rowIndex])

            // Update the state
            setDemandSupply(updatedDataRows);

            resolve(newRow);
            setPromiseArguments(null);
        });
    };

    const renderConfirmDialog = () => {
        if (!promiseArguments) {
            return null;
        }

        const { updatedField, newValue } = promiseArguments;

        return (
            <Dialog open={!!promiseArguments}>
                <DialogTitle>Are you sure?</DialogTitle>
                <DialogContent dividers>
                    {`Pressing 'Yes' will change ${updatedField} to ${newValue}.`}
                </DialogContent>
                <DialogActions>
                    <Button ref={noButtonRef} onClick={handleNo}>
                        No
                    </Button>
                    <Button onClick={handleYes}>Yes</Button>
                </DialogActions>
            </Dialog>
        );
    };

    const toggleLoadingRow = (rowId, isLoading) => {
        const updatedLoadingRows = new Set(loadingRows);
        if (isLoading) {
            updatedLoadingRows.add(rowId);
        } else {
            updatedLoadingRows.delete(rowId);
        }
        setLoadingRows(updatedLoadingRows);
    };

    const handleUpdateConfirm = (rowId, checked) => {
        setUpdatingRowId(rowId);
        setCheckedState(checked);
        setConfirmDialogOpen(true);
    };

    const handleDialogClose = () => {
        setUpdatingRowId(null);
        setConfirmDialogOpen(false);
    };


    const LoadingSkeleton = () => (
        <Box
            sx={{
                height: "max-content"
            }}
        >
            {[...Array(20)].map((item, key) => (
                <Skeleton key={key} variant="rectangular" sx={{my: 2, mx: 1}}/>
            ))}
        </Box>
    );

    const load = async () => {
        await Api.demandSupplyFeeds({start_date: startDate, end_date: endDate}).then(r => {
            setDemandSupply(r)
            setLoading(false)

        })
    }

    useEffect(() => {

        load()

        Api.supplyPartners({}).then(r => {
            setSupplyPartners(r)
        })

        Api.demandPartners({}).then(r => {
            setDemandPartners(r)
        })

        Api.demandFeeds({}).then(r => {
            setDemandFeeds(r)
        })

        Api.supply({}).then(r => {
            setSupplyFeeds(r)
        })


    }, []);

    const handleSupplySwitch = async (id, checked) => {

        toggleLoadingRow(id, true);
        await Api.supplyUpdate({field: 'active', id: id, value: checked})
        await load()
        toggleLoadingRow(id, false)


    };


    const handleDemandSwitch = (id, checked) => {
        handleUpdateConfirm(id, checked);
    };


    const handleCopyToClipboard = (text) => {
        navigator.clipboard.writeText(text).then(
            () => {
                console.log('Copied to clipboard');
            },
            (err) => {
                console.error('Failed to copy text: ', err);
            }
        );
    };


    const handleQuickSearch = (demand_feed_id, supply_feed_id) => {

        console.log(demand_feed_id,supply_feed_id)
        setDataForm({demand_feed_id: demand_feed_id, supply_feed_id:supply_feed_id} )
    }


    const formatNumber = (number, decimals = 2) => {
        const formattedNumber = new Intl.NumberFormat('en-US', {
            minimumFractionDigits: decimals,
            maximumFractionDigits: decimals,
        }).format(number);
        return formattedNumber;
    }

    const CellWarning = styled('div')(({theme}) => ({
        backgroundColor: theme.palette.warning.light,
        color: theme.palette.warning.contrastText,
        padding: theme.spacing(1),

    }));

    const handleFormSubmit = async (data) => {
        console.log("Form data:", data);
        setLoading(true)
        setDataForm(data)

        Api.demandSupplyFeeds(data).then(r => {
                setDemandSupply(r)
                setLoading(false)
            }
        )
    }


    const columns = [
        {
            field: "active",
            headerName: "Active",
            type: "boolean",
            flex: 0.30,
            minWidth: 75,
            editable: true,
        },

        {
            field: "status_demand",
            headerName: "Demand",
            type: "boolean",
            editable: true,
            flex: 0.30,
            minWidth: 75,
            valueGetter: (params) => params.row?.status_demand ?? params.row?.demand_feed.status,

        },
        {
            field: "name",
            headerName: "Name",
            type: "string",
            flex: 0.4,
            minWidth: 150,
            valueGetter: (params) => params.row?.supply_feed.name
        },
        {
            field: "supplyName",
            headerName: "Supply Name",
            type: "string",
            flex: 0.4,
            minWidth: 150,
            valueGetter: (params) => params.row?.supply_feed.user?.name
        },
        {
            field: "demandName",
            headerName: "Demand Name",
            type: "string",
            flex: 0.4,
            minWidth: 150,
            valueGetter: (params) => params.row?.demand_feed.user?.name,
            renderCell: (params) => {
                return (
                    <span style={{display: 'flex', alignItems: 'center'}}>
        {params.row?.demand_feed.user?.name}
                        {params.row?.demand_feed.user.direct == 1 && <Star style={{marginLeft: '5px', fontSize: '1em'}} color={"success"}/>}
      </span>
                );
            },
        },


        {
            field: "supply_feed_id",
            headerName: "S. Feed Id",
            type: 'string',
            flex: 0.3,
            minWidth: 75,

        },
        {
            field: "demand_feed_id",
            headerName: "D. Feed Id",
            type: 'string',
            flex: 0.3,
            minWidth: 75,
        },
        {
            field: "jumps",
            headerName: "Jumps",
            type: 'string',
            editable: false,
            flex: 0.1,
            minWidth: 70,

            // Safely extract the value for "jumps"
            valueGetter: (params) => {
                try {
                    const checkerData = params.row?.demand_feed?.checker_data;
                    const data = checkerData ? JSON.parse(checkerData) : null;
                    return data?.jumps || null; // Return jumps or null
                } catch (error) {
                    console.error("Error parsing checker_data in valueGetter:", error);
                    return null;
                }
            },

            renderCell: (params) => {
                let jumps = null;

                try {
                    const checkerData = params.row?.demand_feed?.checker_data;
                    if (checkerData) {
                        const data = JSON.parse(checkerData);
                        jumps = Array.isArray(data?.jumps) ? data.jumps.length : null;
                    }
                } catch (error) {
                    console.error("Error parsing checker_data or accessing jumps in renderCell:", error);
                }

                return jumps ? (
                    <a
                        href={"#" + params.row.id + "checker"}
                        onClick={(e) => {
                            e.preventDefault();
                            searchParams.set('checker', true);
                            searchParams.set('data', params.row?.demand_feed?.checker_data);
                            setSearchParams(searchParams);
                        }}
                    >
                        {jumps}
                    </a>
                ) : ""; // Return an empty string if no jumps
            }
        },
        {
            field: "created_at",
            headerName: "Created At",
            type: "datetime",
            flex: 0.3,
            minWidth: 75,
            valueFormatter: (params) => {
                if (!params.value) return "-"
                const createdAt = parseISO(params.value);
                return formatDistanceToNow(createdAt, {addSuffix: true});
            },
            valueGetter: (params) => params.row?.created_at ?? ''
        },
        {
            field: "needle",
            headerName: "Needle",
            type: "string",
            flex: 0.3,
            minWidth: 75,
            valueGetter: (params) => params.row?.demand_feed.needle

        },
        {
            field: "type",
            headerName: "Type",
            type: "string",
            flex: 0.3,
            minWidth: 50,
            valueGetter: (params) => params.row?.demand_feed.type?.name

        },
        {
            field: "capping",
            headerName: "Rel. CAP",
            type: "number",
            flex: 0.3,
            editable: true,
            minWidth: 75,
            valueGetter: (params) => params.row?.capping

        },

        {
            field: "d_capping",
            headerName: "D. CAP",
            type: "number",
            flex: 0.3,
            editable: true,
            minWidth: 75,
            valueGetter: (params) => params.row?.d_capping ?? params.row?.demand_feed.capping

        },
        {
            field: "margin",
            headerName: "Margin",
            type: "number",
            flex: 0.3,
            editable: true,
            minWidth: 75,
            valueGetter: (params) => params.row?.supply_feed.current_margin?.margin ?? params.row?.supply_feed.user.current_margin?.margin ?? params.row?.supply_feed.user.margin

        },
        {
            field: "searches",
            headerName: "Searches",
            type: "number",
            flex: 0.3,
            minWidth: 120,
            valueFormatter: (params) => formatNumber(params.value, 0),

            valueGetter: (params) => params.row?.stats?.searches ?? 0

        },
        {
            field: "monetized_searches",
            headerName: "M. Searches",
            type: "number",
            hide: true,
            flex: 0.3,
            minWidth: 120,
            valueFormatter: (params) => formatNumber(params.value, 0),

            valueGetter: (params) => params.row?.stats?.monetized_searches ?? 0

        },
        {
            field: "clicks",
            headerName: "Clicks",
            type: "number",
            hide: true,
            flex: 0.3,
            minWidth: 75,
            valueFormatter: (params) => formatNumber(params.value, 0),

            valueGetter: (params) => params.row?.stats?.clicks ?? 0

        },
        {
            field: "publisher_revenue",
            headerName: "Pub. Rev.",
            type: "number",
            hide: true,
            flex: 0.3,
            minWidth: 120,
            valueFormatter: (params) => "$" + formatNumber(params.value),
            valueGetter: (params) =>
                params.row?.stats?.publisher_revenue ?? 0


        },
        {
            field: "fraud_rate",
            headerName: "Opticks %",
            type: "number",
            hide: true,
            flex: 0.3,
            minWidth: 75,
            valueFormatter: (params) => formatNumber(params.value * 100) + "%",
            valueGetter: (params) =>
                params.row?.stats?.fraud_rate ?? 0,
            cellClassName: (params) =>
                params.row?.stats?.fraud_rate > 0.3 ? "cell-warning" : ''


        },
        {
            field: "latency",
            headerName: "Latency (ms)",
            type: "number",
            flex: 0.3,
            minWidth: 75,
            hide: true,
            valueFormatter: (params) => formatNumber(params.value, 0),
            valueGetter: (params) =>
                params.row?.stats?.latency ?? 0


        },
        {
            field: "rpm",
            headerName: "RPM",
            type: "number",
            hide: true,
            flex: 0.3,
            minWidth: 75,
            valueFormatter: (params) => "$" + formatNumber(params.value),

            valueGetter: (params) =>
                params.row?.stats?.publisher_revenue && params.row?.stats?.searches
                    ? (params.row?.stats?.publisher_revenue / params.row?.stats?.searches) * 1000
                    : 0

        },
        {
            field: "coverage",
            headerName: "Coverage",
            type: "number",
            flex: 0.3,
            hide: true,
            minWidth: 75,
            valueFormatter: (params) => formatNumber(params.value) + "%",

            valueGetter: (params) =>
                params.row?.stats?.monetized_searches && params.row?.stats?.searches
                    ? (params.row?.stats?.monetized_searches / params.row?.stats?.searches) * 100
                    : 0

        },
        {
            field: "CTR",
            headerName: "CTR",
            type: "number",
            hide: true,
            flex: 0.3,
            minWidth: 75,
            valueFormatter: (params) => formatNumber(params.value) + "%",

            valueGetter: (params) => params.row?.stats?.clicks && params.row?.stats?.searches
                ? (params.row?.stats?.clicks / params.row?.stats?.searches) * 100
                : 0

        },

        {
            field: "actions",
            headerName: "Actions",
            type: "string",
            flex: 0.3,
            minWidth: 100,
            renderCell: (item) => {
                return ([
                    <>
                        <Tooltip title="Copy Full Sharing to clipboard" arrow={true}>

                            <IconButton
                                edge="end"
                                color="secondary"
                                onClick={() => {
                                    handleCopyToClipboard(
                                        `Name: ${item.row.supply_feed.name}
Tracking Url: https://${item.row.supply_feed.domain.domain}/track/${item.row.supply_feed.id}/?q={keyword}
Device: ${
                                            item.row.demand_feed.desktop && item.row.demand_feed.mobile ? "Mobile and Desktop" :
                                                !item.row.demand_feed.desktop && item.row.demand_feed.mobile ? "Mobile" :
                                                    item.row.demand_feed.desktop && !item.row.demand_feed.mobile ? "Desktop" :
                                                        ''
                                        }
CAP: ${item.row.capping} searches/day
-----------
>> Extra macros: {click_id} *required for postback
${item.row.demand_feed.type.name == "BHS" ? ">> Benchmarks: Ad Coverage >80%; CTR 8-11%; FOS: 9-12% Do NOT send too much traffic and follow the cap provided above. \n" +
                                            ">> We may also be forced to stop if invalid, automated or fake traffic detected. \n" +
                                            "**Note: If all looks good, we are able to increase the cap or provide new feeds.  :)" : ">> Benchmarks: Ad Coverage >80%; CTR 20-40%; Do NOT send too much traffic and follow the cap provided above.\n" +
                                            ">> We may also be forced to stop if invalid, automated or fake traffic detected.\n" +
                                            "**Note: If all looks good, we are able to increase the cap or provide new feeds.  :)"}`
                                    )
                                }}
                            >
                                <Share/>
                            </IconButton>
                        </Tooltip>

                    </>,<IconButton  sx={{ml: 1}} color="primary" aria-label="Quick Stats">
                            <QueryStats onClick={() => handleQuickSearch(item.row.demand_feed_id, item.row.supply_feed_id)}/></IconButton>]
                );
            },
        },
    ];




    return (
        <MainLayout>
            <Container maxWidth="2xl" sx={{mt: 4, mb: 4}}>
                <Paper sx={{p: 2}}>
            <KPIS dataForm={dataForm} />
                </Paper>
            </Container>
            <Container maxWidth="2xl" sx={{mt: 4, mb: 4}}>
                <Paper sx={{p: 2}}>
                    <Title>All Feeds</Title>

                    <form onSubmit={handleSubmit(handleFormSubmit)}>

                        <Grid container spacing={2}>

                            <Grid item container xs={12} sm={10} spacing={2} justifyContent="flex-start">
                                <Grid item xs={10} sm={2}>
                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                        <Controller
                                            name="date_from"
                                            control={control}
                                            defaultValue={null}
                                            render={({field}) => (
                                                <DatePicker
                                                    label="Start Date"
                                                    value={field.value}
                                                    slotProps={{ textField: { size: 'small', fullWidth: true } }}

                                                    onChange={(value) => field.onChange(value)}
                                                    textField={(params) => <TextField fullWidth
                                                                                        size="small" {...params} />}
                                                />
                                            )}
                                        />
                                    </LocalizationProvider>
                                </Grid>

                                <Grid item xs={10} sm={2}>
                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                        <Controller
                                            name="date_to"
                                            control={control}
                                            defaultValue={null}
                                            render={({field}) => (
                                                <DatePicker
                                                    label="End Date"
                                                    value={field.value}
                                                    slotProps={{ textField: { size: 'small', fullWidth: true } }}
                                                    onChange={(value) => field.onChange(value)}
                                                    textField={(params) => <TextField fullWidth
                                                                                        size="small" {...params} />}
                                                />
                                            )}
                                        />
                                    </LocalizationProvider>
                                </Grid>
                                <Grid item xs={10} sm={2}>
                                    <Autocomplete
                                        options={supplyPartners}

                                        getOptionLabel={(option) => `${option.id} - ${option.name}`}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label="Publisher ID"

                                                size="small"
                                            />
                                        )}
                                        onChange={(_, value) => setValue("publisher_id", value ? value.id : "")}
                                        value={supplyPartners.find((supply) => supply.id === watch("publisher_id")) || null}
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item xs={10} sm={2}>
                                    <Autocomplete
                                        options={demandPartners}

                                        getOptionLabel={(option) => `${option.id} - ${option.name}`}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label="Demand ID"

                                                size="small"
                                            />
                                        )}
                                        onChange={(_, value) => setValue("demand_id", value ? value.id : "")}
                                        value={demandPartners.find((supply) => supply.id === watch("demand_id")) || null}
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item xs={10} sm={2}>
                                    <Autocomplete
                                        options={demandFeeds}

                                        getOptionLabel={(option) => `${option.id} - ${option.needle}`}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label="Demand Feed Id"

                                                size="small"
                                            />
                                        )}
                                        onChange={(_, value) => setValue("demand_feed_id", value ? value.id : "")}
                                        value={demandFeeds.find((demandFeed) => demandFeed.id === watch("demand_feed_id")) || null}
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item xs={10} sm={2}>
                                    <Autocomplete
                                        options={supplyFeeds}

                                        getOptionLabel={(option) => `${option.id} - ${option.name}`}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label="Supply Feed Id"

                                                size="small"
                                            />
                                        )}
                                        onChange={(_, value) => setValue("supply_feed_id", value ? value.id : "")}
                                        value={supplyFeeds.find((supplyFeed) => supplyFeed.id === watch("supply_feed_id")) || null}
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item xs={10} sm={2}>
                                    <FormControl fullWidth>
                                        <InputLabel id="network">Network</InputLabel>
                                        <Select
                                            labelId="network"
                                            id="network"
                                            label="Network"
                                            {...register("network",)}
                                            size={"small"}
                                            defaultValue={0}
                                            onChange={(_, value) => setValue("network", value ? value.id : "")}
                                        >
                                            <MenuItem value={0}>ALL</MenuItem>
                                            <MenuItem value={1}>Only Network</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={4} sm={1}>
                                    <Button variant="contained" type="submit">Filter</Button>
                                </Grid>

                            </Grid>

                            <Grid item container xs={12} sm={2} justifyContent="flex-end">
                                <Grid item>
                                    <CreateFeed load={load} setLoading={setLoading}/>
                                </Grid>
                            </Grid>
                        </Grid>
                    </form>


                    <DataGrid
                        rows={!loading ? demandSupply : []}
                        columnVisibilityModel={{
                            monetized_searches: false,
                            clicks: false,
                            latency: false,
                            name: false,
                        }}
                        columns={columns}
                        pageSize={pageSize}
                        onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                        autoHeight={true}
                        processRowUpdate={(newRow, oldRow) =>
                            new Promise((resolve, reject) => {
                                const [updatedField, newValue] = Object.entries(newRow).find(([key, value]) => oldRow[key] !== value) || [];


                                setPromiseArguments({ resolve, oldRow, newRow, updatedField, newValue });
                            })


                        }

                        onProcessRowUpdateError={(error) => {
                            console.log(error)
                        }}

                        disableRowSelectionOnClick={true}

                        components={{
                            LoadingOverlay: LoadingSkeleton,
                            Toolbar: GridToolbar,

                        }}

                        componentsProps={{
                            toolbar: {
                                showQuickFilter: true,
                                quickFilterProps: {debounceMs: 500},
                            },
                        }}


                        rowsPerPageOptionsSkeleton

                        sx={{
                            mt: 2,
                            mb: 2,
                            minHeight: 600,
                        }}
                        getRowId={(row) => row.demand_feed_id + "-" + row.supply_feed_id}
                        density={"compact"}
                        loading={loading}
                    />

                    {renderConfirmDialog()}

                </Paper>

                <Dialog
                    open={confirmDialogOpen}
                    onClose={handleDialogClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">{"Update status?"}</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            Are you sure you want to update the status of this demand, it will affect all the supply
                            feeds assigned to this demand?
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleDialogClose} color="primary">
                            Cancel
                        </Button>
                        <Button
                            onClick={async () => {
                                setConfirmDialogOpen(false);
                                // Call your update API function here with the updatingRowId and new checked state
                                setLoading(true);
                                await Api.updateDemandFeed({field: "status", id: updatingRowId, value: checkedState});
                                await load()
                                setLoading(false)
                                handleDialogClose();
                            }}
                            color="primary"
                            autoFocus
                        >
                            Confirm
                        </Button>
                    </DialogActions>
                </Dialog>
            </Container>
        </MainLayout>
    )

}

export default DemandSupply